export default __webpack_public_path__ + "static/media/validation-hover.19c602b8.svg";